/**
 * Schritt 2 "Felder" (33b) — Pflichtfelder (readonly) + Standard-Toggles + Eigene Felder.
 * 1:1 aus dem alten Drawer in widgets-tab.tsx gehoben (dort Zeilen ~726-858 vor dem Umbau).
 */
import { Button, Card, Icon, Checkbox } from "../../../ui/components";
import { EDITOR_PFLICHTFELDER, EDITOR_STANDARDFELDER } from "../../widgets-tab";
import { CustomFieldEditor } from "./fields/CustomFieldEditor";
import { FolgefrageEditor } from "./fields/FolgefrageEditor";
import type { WidgetEditor } from "../useWidgetEditorForm";

export default function FieldsStep({ editor, onNext }: { editor: WidgetEditor; onNext: () => void }) {
  return (
    <div className="space-y-4">
      <Card className="space-y-4 p-4">
        <div>
          <p className="font-body-sm text-body-sm font-semibold text-on-surface dark:text-inverse-on-surface">Pflichtfelder</p>
          <p className="mt-1 font-label-md text-label-md text-on-surface-variant">
            Diese Angaben braucht MAESTRO, um aus einer Anfrage ein Angebot machen zu können. Sie sind fest und lassen sich nicht
            abwählen. E-Mail oder Telefon: mindestens eines davon muss der Gast ausfüllen.
          </p>
          <ul className="mt-2 grid gap-1 sm:grid-cols-2">
            {EDITOR_PFLICHTFELDER.map((f) => (
              <li key={f.key} className="flex items-center gap-2 opacity-60">
                <Checkbox checked disabled readOnly />
                <span className="font-body-sm text-body-sm text-on-surface dark:text-inverse-on-surface">{f.label}</span>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-body-sm text-body-sm font-semibold text-on-surface dark:text-inverse-on-surface">Zusätzliche Standardfelder</p>
          <p className="mt-1 font-label-md text-label-md text-on-surface-variant">
            Felder, die MAESTRO bereits kennt und automatisch der Anfrage zuordnet. Die Budgetvorstellung ist reiner Freitext —
            sie wird nie als Preis übernommen.
          </p>
          <ul className="mt-2 grid gap-1 sm:grid-cols-2">
            {EDITOR_STANDARDFELDER.map((f) => (
              <li key={f.key}>
                <label className="flex items-center gap-2">
                  <Checkbox
                    checked={editor.form.standardfelder.includes(f.key)}
                    onChange={() => editor.toggleStandardfeld(f.key)}
                  />
                  <span className="font-body-sm text-body-sm text-on-surface dark:text-inverse-on-surface">{f.label}</span>
                </label>
              </li>
            ))}
          </ul>
          <p className="mt-2 font-label-md text-label-md text-on-surface-variant">
            Seite, verweisende Seite und utm-Parameter werden immer automatisch erfasst — sie sind für den Gast unsichtbar.
          </p>
        </div>

        <CustomFieldEditor editor={editor} />
      </Card>

      <FolgefrageEditor editor={editor} />

      <div className="flex justify-end">
        <Button type="button" onClick={onNext}>
          Weiter <Icon name="arrow_forward" className="text-[16px]" />
        </Button>
      </div>
    </div>
  );
}
